import { translation } from '../core';
import type { fr } from './fr';

export const en = translation<typeof fr>()({
  'vehicle.open': 'View {name}, {total} for {days}',
  'vehicle.deposit': 'Deposit {amount}',
  'vehicle.freeDelivery': 'Free delivery',
  'vehicle.perDay': '{price} / day · {days}',
  'experience.perPerson': '/ person',
  'experience.perVehicle': '/ vehicle',
  'experience.from': 'from',
  'experience.open': '{title}, from {price} {unit}',
  'experience.openRated': {
    one: '{title}, from {price} {unit}, rated {rating} out of 5 ({count} review)',
    other: '{title}, from {price} {unit}, rated {rating} out of 5 ({count} reviews)',
  },
  'experience.openNoPrice': '{title}',
  'experience.openNoPriceRated': {
    one: '{title}, rated {rating} out of 5 ({count} review)',
    other: '{title}, rated {rating} out of 5 ({count} reviews)',
  },
  'experience.rating': '{rating} ({count})',
  'favourite.add': 'Add {name} to favourites',
  'favourite.remove': 'Remove {name} from favourites',
  'favourite.added': 'Added to favourites',
  'favourite.removed': 'Removed from favourites',
  'favourite.signIn': 'Sign in to save your favourites.',
  'favourite.error': 'Your favourites could not be changed. Try again in a moment.',
  'price.loading': 'Calculating the price',
  'price.estimate': 'Estimate',
  'price.estimateHint': 'Price calculated before sign-in: the exact amount is confirmed at the next step.',
  'support.label': 'Contact support',
  'support.call': 'Call {phone}',
  'support.email': 'Email',
  'support.emailTo': 'Email: {email}',
  'google.continue': 'Continue with Google',
  'google.busy': 'Signing in with Google…',
});
